<h1 [class.editMode]="editMode">{{ editMode ? 'Edit ' : 'New ' }}{{ model }}</h1>
